import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { apiClient } from '../apiClient';
import {
  CreateAuditScheduleRequest,
  CreateAuditScheduleResponse,
  GetAuditScheduleRequest,
  GetAuditScheduleResponse,
  ListAuditSchedulesRequest,
  ListAuditSchedulesResponse,
  UpdateAuditScheduleRequest,
  UpdateAuditScheduleResponse,
} from 'src/types/helios/AuditSchedule';

export const scheduleService = {
  // Get all schedules
  getAll: (data: ListAuditSchedulesRequest) => {
    return apiClient.get<ListAuditSchedulesResponse>(
      ServiceType.HELIOS,
      createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.SCHEDULES.ALL(data.businessUnitId)),
      data,
    );
  },

  // Get schedule by ID
  getById: (data: GetAuditScheduleRequest) => {
    return apiClient.get<GetAuditScheduleResponse>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.SCHEDULES.BY_ID(
          data.businessUnitId,
          data.scheduleId,
        ),
      ),
      data,
    );
  },

  // Create new schedule
  create: (data: CreateAuditScheduleRequest) => {
    return apiClient.post<CreateAuditScheduleResponse, CreateAuditScheduleRequest>(
      ServiceType.HELIOS,
      createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.SCHEDULES.CREATE(data.businessUnitId)),
      data,
    );
  },

  // Update schedule
  update: (data: UpdateAuditScheduleRequest) => {
    return apiClient.put<UpdateAuditScheduleResponse, UpdateAuditScheduleRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.SCHEDULES.UPDATE(
          data.businessUnitId || '',
          data.scheduleId,
        ),
      ),
      data,
    );
  },

  // Delete schedule
  delete: (businessUnitId: string, scheduleId: string) => {
    return apiClient.delete(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.SCHEDULES.DELETE(businessUnitId, scheduleId),
      ),
    );
  },
};
